import { Component, OnInit, Input, ChangeDetectionStrategy, inject } from "@angular/core";
import { ModalController, IonButton, IonContent, IonHeader, IonIcon, IonItem, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { OtherKeyWords } from "src/components/shared-components/enum/enumMisc";
import { PlatformModeContentDirective } from "../../../../../directive/platform-mode-content.directive";

@Component({
    selector: "app-popup-keyword",
    templateUrl: "./popup-keyword.component.html",
    styleUrls: ["./popup-keyword.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, IonContent, IonHeader, IonIcon, IonItem, IonRadio, IonRadioGroup, IonTitle, IonToolbar, PlatformModeContentDirective, TranslatePipe]
})
export class PopupKeywordComponent implements OnInit {
    private readonly _modalCtrl = inject(ModalController);
    private readonly _translateService = inject(TranslateService);

    public keywordsList: Array<{
        title: string;
        description: string;
    }> = null;

    @Input() selectedItem: string = "";

    ngOnInit() {
        this.initializeKeywordsList();
    }

    /**
     * Exit without choosing an option
     */
    public onClickCancel(): void {
        this._modalCtrl.dismiss();
    }

    /**
     * Selection of keyword
     * @param keyword 
     */
    public onClickKeyword(keyword: string) {
        this._modalCtrl.dismiss(keyword);
    }

    /**
     * Initialization of keywords list
     */
    private initializeKeywordsList(): void {
        this.keywordsList = [
            {
                title: OtherKeyWords.VALUE,
                description: this._translateService.instant("dictionary.valueKeywordDesc"),
            },
            {
                title: OtherKeyWords.FORMATTEDVALUE,
                description: this._translateService.instant("dictionary.formattedValueKeywordDesc"),
            },
            {
                title: OtherKeyWords.TIMESTAMP,
                description: this._translateService.instant("dictionary.timestampKeywordDesc")
            },
            {
                title: OtherKeyWords.NAME,
                description: this._translateService.instant("dictionary.nameKeywordDesc"),
            },
            {
                title: OtherKeyWords.FULLNAME,
                description: this._translateService.instant("dictionary.fullnameKeywordDesc"),
            },
            {
                title: OtherKeyWords.ADDRESS,
                description: this._translateService.instant("dictionary.addressKeywordDesc"),
            },
            {
                title: OtherKeyWords.HILEVELDATAFORMAT,
                description: this._translateService.instant("dictionary.hiLevelDataFormatKeywordDesc"),
            },
            {
                title: OtherKeyWords.TECHVALUE,
                description: this._translateService.instant("dictionary.techvalueKeywordDesc"),
            },
            {
                title: OtherKeyWords.MEASUREUNIT,
                description: this._translateService.instant("dictionary.measureUnitKeywordDesc"),
            },
            {
                title: OtherKeyWords.ROOMNUMBER,
                description: this._translateService.instant("dictionary.roomNumberKeywordDesc"),
            },
            {
                title: OtherKeyWords.ROOMNAME,
                description: this._translateService.instant("dictionary.roomNameKeywordDesc")
            },
            // {
            //     title: OtherKeyWords.VIRTUALROOMNUMBER,
            //     description: this._lblVirtualRoomNumberKeyDesc,
            // },
            // {
            //     title: OtherKeyWords.VIRTUALROOMNAME,
            //     description: this._lblVirtualRoomNameKeyDesc,
            // },
            {
                title: OtherKeyWords.DECIMALDIGITSN,
                description: this._translateService.instant("dictionary.decimalDigitsNKeywordDesc")
            },
        ]
    }
}